import PropTypes from 'prop-types';

const locationKeys = {
	hash: PropTypes.string,
	key: PropTypes.string,
	pathname: PropTypes.string,
	search: PropTypes.string,
	state: PropTypes.object,
};

export const reactRouterPropTypes = {
	history: PropTypes.shape({
		action: PropTypes.string,
		block: PropTypes.func,
		createHref: PropTypes.func,
		go: PropTypes.func,
		goBack: PropTypes.func,
		goForward: PropTypes.func,
		length: PropTypes.number,
		listen: PropTypes.func,
		location: PropTypes.shape({
			...locationKeys,
		}),
		push: PropTypes.func,
		replace: PropTypes.func,
	}),
	location: PropTypes.shape({
		...locationKeys,
	}),
	match: PropTypes.shape({
		isExact: PropTypes.bool,
		params: PropTypes.object,
		path: PropTypes.string,
		url: PropTypes.string,
	}),
	staticContext: PropTypes.object,
};
